export enum OrganizationCommunityMembershipStatus {
  Pending = 'Pending',
  Active = 'Active',
  Disabled = 'Disabled',
  Denied = 'Denied'
}


// WEBPACK FOOTER //
// ./src/modules/organization/models/OrganizationCommunityMembershipStatus.ts